module.exports = __webpack_public_path__ + "static/media/Episode_Hero_Mobile_1.1af0a30e.png";